import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { RegisterService } from '@core/services/register.service';

export const registerFormGuard: CanActivateFn = () => {
  const router = inject(Router);
  const registerService = inject(RegisterService);

  const isValidToken = registerService.validateRegisterVerificationToken();
  if (isValidToken) {
    return true;
  }

  registerService.showInvalidMessageRegisterVerificationToken();
  return router.createUrlTree(['/register']);
};
